import { ListItemText } from '@mui/material';
import dayjs from 'dayjs';

import { PONDURANCE_NAME } from '@/constants/common';
import { humanizeTime } from '@/pages/Administration/Devices/Devices.service';
import getDateTime from '@/utils/getDateTime.utils';

import type { TicketWithoutUserOwner } from './DashboardInternal.types';

export const dateFormatter = (dateValue: string) => {
  // Local time conversion is handled inside humanizeTime itself.
  return (
    <ListItemText
      primary={humanizeTime(dateValue, true)}
      secondary={getDateTime(dateValue)}
      sx={{ margin: 0 }}
    />
  );
};

// Tickets due within 24 hours
export const getDueNowTickets = (dueNowTickets: TicketWithoutUserOwner[]) => {
  return dueNowTickets.filter(
    (ticket) =>
      dayjs.utc(ticket.followup_date).local().isAfter(dayjs()) &&
      dayjs.utc(ticket.followup_date).local().isBefore(dayjs().add(1, 'day'))
  );
};

// Tickets that are past the follow up date
export const getPastDueTickets = (pastDueTickets: TicketWithoutUserOwner[]) => {
  return pastDueTickets.filter((ticket) =>
    dayjs.utc(ticket.followup_date).local().isBefore(dayjs(), 'day')
  );
};

// Tickets that have not been updated in 14 days or were created over 30 days ago
export const getRiskyTickets = (riskyTickets: TicketWithoutUserOwner[]) => {
  return riskyTickets.filter(
    (ticket) =>
      dayjs
        .utc(ticket.updated_at)
        .local()
        .isBefore(dayjs().subtract(14, 'day')) ||
      dayjs.utc(ticket.created_at).local().isBefore(dayjs().subtract(30, 'day'))
  );
};

export const getNextActionOwnerTickets = (
  nextActionOwnerTickets: TicketWithoutUserOwner[]
) => {
  return nextActionOwnerTickets.filter(
    (ticket) => ticket.next_action_owner === PONDURANCE_NAME
  );
};

export const ticketTypeFormatted = (ticketType: number) => {
  switch (ticketType) {
    case 1:
      return 'Threat';
    case 2:
      return 'Service';
    default:
      return '';
  }
};

export default dateFormatter;
